/* globals twttr */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/cards/twitter.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

class TwitterCard extends PureComponent {
    constructor(props) {
        super(props);

        this.refContainer = null;
    }

    componentDidMount() {
        if (typeof twttr !== 'undefined') {
            twttr.widgets.load(this.refContainer);
        }
    }

    render() {
        const { className } = this.props;
        return (
            <div
                className={classNames({
                    [styles.container]: true,
                    [className]: className !== null,
                })}
                ref={(ref) => { this.refContainer = ref; }}
            >
                <a
                    className="twitter-timeline"
                    href="https://twitter.com/catbirdprod"
                    data-chrome="nofooter noborders"
                    data-width="300"
                    data-height="450"
                >
                    Tweets by @catbirdprod
                </a>
            </div>
        );
    }
}

TwitterCard.propTypes = propTypes;
TwitterCard.defaultProps = defaultProps;

export default TwitterCard;



// WEBPACK FOOTER //
// ./js/components/cards/Twitter.jsx